import React, { useState } from 'react';
import { UploadCloudIcon, FileTextIcon, Loader2Icon, CheckCircleIcon, SparklesIcon, TargetIcon, AlertCircleIcon, DollarSignIcon } from 'lucide-react';
export function ProductAnalyzer() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [content, setContent] = useState('');
  const handleAnalyze = () => {
    if (!content) return;
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2000);
  };
  return <div className="max-w-4xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-505">
      <div data-id="element-506">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-507">
          Analizador de Producto
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-508">
          Sube tu eBook o pega el contenido para extraer los ángulos de venta
          perfectos.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-509">
        <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-510">
          Contenido del Producto o URL de Ventas
        </label>
        <textarea value={content} onChange={e => setContent(e.target.value)} placeholder="Pega aquí el índice de tu eBook, la introducción, o la URL de tu página actual..." className="w-full h-40 p-4 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none" data-id="element-511" />

        <div className="mt-4 flex items-center justify-center w-full" data-id="element-512">
          <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-slate-300 border-dashed rounded-lg cursor-pointer bg-slate-50 hover:bg-slate-100 transition-colors" data-id="element-513">
            <div className="flex flex-col items-center justify-center pt-5 pb-6" data-id="element-514">
              <UploadCloudIcon className="w-8 h-8 text-slate-400 mb-2" data-id="element-515" />
              <p className="text-sm text-slate-500" data-id="element-516">
                <span className="font-semibold text-indigo-600" data-id="element-517">
                  Haz clic para subir
                </span>{' '}
                o arrastra tu PDF
              </p>
            </div>
            <input type="file" className="hidden" accept=".pdf,.doc,.docx" data-id="element-518" />
          </label>
        </div>

        <div className="mt-6 flex justify-end" data-id="element-519">
          <button onClick={handleAnalyze} disabled={!content || isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-520">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-521" /> Analizando con
                IA...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-522" /> Analizar Producto
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-523">
          <div className="flex items-center justify-between" data-id="element-524">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-525">
              Ficha de Producto Generada
            </h2>
            <div className="flex items-center gap-2 bg-green-50 text-green-700 px-3 py-1 rounded-full text-sm font-medium border border-green-200" data-id="element-526">
              <CheckCircleIcon className="w-4 h-4" data-id="element-527" />
              Conversion Score: 92/100
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-528">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 space-y-4" data-id="element-529">
              <div className="flex items-start gap-3" data-id="element-530">
                <div className="p-2 bg-indigo-100 text-indigo-600 rounded-lg shrink-0" data-id="element-531">
                  <FileTextIcon className="w-5 h-5" data-id="element-532" />
                </div>
                <div data-id="element-533">
                  <h3 className="font-semibold text-slate-900" data-id="element-534">
                    Propuesta de Valor
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-535">
                    De aficionada a la repostería a dueña de un negocio rentable
                    desde casa vendiendo postres en porciones, sin necesidad de
                    local comercial ni equipos industriales.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 space-y-4" data-id="element-536">
              <div className="flex items-start gap-3" data-id="element-537">
                <div className="p-2 bg-pink-100 text-pink-600 rounded-lg shrink-0" data-id="element-538">
                  <TargetIcon className="w-5 h-5" data-id="element-539" />
                </div>
                <div data-id="element-540">
                  <h3 className="font-semibold text-slate-900" data-id="element-541">
                    Audiencia Objetivo (ICP)
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-542">
                    Mujeres hispanas (25-45 años), madres que buscan ingresos
                    extra desde casa. Les gusta cocinar pero no saben costear ni
                    vender por redes sociales.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 space-y-4" data-id="element-543">
              <div className="flex items-start gap-3" data-id="element-544">
                <div className="p-2 bg-amber-100 text-amber-600 rounded-lg shrink-0" data-id="element-545">
                  <AlertCircleIcon className="w-5 h-5" data-id="element-546" />
                </div>
                <div data-id="element-547">
                  <h3 className="font-semibold text-slate-900" data-id="element-548">
                    Puntos de Dolor (Pain Points)
                  </h3>
                  <ul className="text-slate-600 text-sm mt-1 list-disc pl-4 space-y-1" data-id="element-549">
                    <li data-id="element-550">Venden muy barato y no ven ganancia real.</li>
                    <li data-id="element-551">Miedo a cobrar lo justo por "ser casero".</li>
                    <li data-id="element-552">No saben tomar fotos atractivas con el celular.</li>
                    <li data-id="element-553">Desperdician ingredientes por mala planificación.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 space-y-4" data-id="element-554">
              <div className="flex items-start gap-3" data-id="element-555">
                <div className="p-2 bg-emerald-100 text-emerald-600 rounded-lg shrink-0" data-id="element-556">
                  <DollarSignIcon className="w-5 h-5" data-id="element-557" />
                </div>
                <div data-id="element-558">
                  <h3 className="font-semibold text-slate-900" data-id="element-559">
                    Mecanismo Único
                  </h3>
                  <p className="text-slate-600 text-sm mt-1" data-id="element-560">
                    El "Método Porción-Rentable™": Una fórmula exacta para
                    costear postres por porción individual, asegurando un margen
                    mínimo del 60% en cada venta por WhatsApp.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}